import { render, staticRenderFns } from "./AppNextLink.vue?vue&type=template&id=53e9574a&scoped=true"
import script from "./AppNextLink.vue?vue&type=script&lang=js"
export * from "./AppNextLink.vue?vue&type=script&lang=js"
import style0 from "./AppNextLink.vue?vue&type=style&index=0&id=53e9574a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e9574a",
  null
  
)

export default component.exports